<template>
    <div class="image-edit"
         onselectstart="return false">
        <p class="image-edit-title">图片编辑
            <i title="关闭"
               class="image-edit-close el-icon-close"
               @click="closePopup"></i>
        </p>
        <div class="point-list position_a">
            <div class="point-list-box">
                <!--<p class="tabs-title item">分项选择</p>-->
                <p v-for="(item, key) of pointTypeList"
                   :key="key"
                   title="点击添加点位"
                   class="item cursor_pointer operate"
                   :class="{'actived': currentTabsKey === key}"
                   @click="checkTabs(key)">
                    {{ item.text }}</p>
                <div class="isFull">
                    <el-checkbox v-model="fullScreen">是否缩放</el-checkbox>
                </div>
            </div>
        </div>
        <!--图片显示区域-->
        <div class="img-area position_a" ref="imgContainer">
            <!--图片层-->
            <div class="img-box">
                <img ref="showImg"
                     :style="{ width: imgInfo.width + 'px', height: imgInfo.height + 'px' }"
                     :src="imgInfo.url"
                     alt=""/>
            </div>
            <!--鼠标操作层-->
            <div ref="mouseMark"
                 class="mouse-mark position_a"
                 :style="{width: imgInfo.width + 'px', height: imgInfo.height + 'px'}">
                <span @mousemove="mouseDownAndMove($event)" @mousedown="pointMouseDown($event, index)" v-for="(item, index) of pointTypeList.energy.pointsArr"><a class="point"
                   :key="index"
                   :class="{'finished' : item.finishedStatus}"
                   :style="{left: item.pointX+'px', top: item.pointY+'px'}"
                   @dblclick.self="pointDblclick(index,$event)"
                ></a></span>
                <!--项目-内容编辑弹窗imgEditConfigInject.type=='project'-->
                <div class="content-edit position_a project"
                     :style="{left: editPopupSize.left + 'px', top: editPopupSize.top + 'px'}"
                     v-show="showEditPopup">
                    <a class="conner position_a"
                       :style="{}"></a>
                    <i title="关闭"
                       @click="closePonit"
                       class="el-icon-close close position_a"></i>
                    <p class="title">参数配置</p>
                    <p class="ipt-item">
                        <span class="sigle-title">名称：</span>
                        <input class="sigle-ipt" type="text" :style="{width: 260*rate+'px'}" v-model="currentPointUnitForm.mapName" maxLength="10">
                    </p>
                    <p class="ipt-item fl" :style="{width: 160*rate+'px'}">
                        <span class="sigle-title">X坐标：</span>
                        <span class="locate-text">{{ currentPointUnitForm.pointX }}</span>
                    </p>
                    <p class="ipt-item fl">
                        <span class="sigle-title">Y坐标：</span>
                        <span class="locate-text">{{ currentPointUnitForm.pointY }}</span>
                    </p>
                      <div class="ipt-item" style="clear: both;">
                        <div class="fl row">
                            <el-checkbox v-model="currentPointUnitForm.eleChecked" @change="((val)=>clearData(val,currentPointUnitForm,'electricity'))">总电耗</el-checkbox>
                        </div>
                        <div class="fl">
                            <el-select v-model="currentPointUnitForm.eleType" placeholder="请选择" @change="change" :style="{width:100*rate+'px',height:36*rate+'px'}" :disabled="!currentPointUnitForm.eleChecked">
                                <el-option
                                v-for="item in category"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fl" :style="{marginLeft: 5*rate+'px'}">
                                <treeSelect
                                    :style="{width:155*rate+'px'}"
                                    v-model="currentPointUnitForm.eleCode"
                                    placeholder="请选择"
                                    :clearable="false"
                                    :data="projectInfo.electricity.treeConfig.dataArr"
                                    :isMultiple="false"
                                    :onlyLeafSelect="true"
                                    :defaultProps="defaultProps1"
                                    v-if="currentPointUnitForm.eleType==2"
                                    :disabled="!currentPointUnitForm.eleChecked"
                                    ></treeSelect>
                                <treeSelect
                                    :style="{width:155*rate+'px'}"
                                    v-model="currentPointUnitForm.eleCode"
                                    placeholder="请选择"
                                    :clearable="false"
                                    v-else
                                    :data="projectInfo.electricity.treeConfig.dataArr"
                                    :isMultiple="false"
                                    :onlyLeafSelect="true"
                                    :defaultProps="defaultProps"
                                    :disabled="!currentPointUnitForm.eleChecked"
                                    ></treeSelect>
                        </div>
                    </div>
                      <div class="ipt-item" style="clear: both;">
                        <div class="fl row">
                            <el-checkbox v-model="currentPointUnitForm.waterChecked" @change="((val)=>clearData(val,currentPointUnitForm,'water'))">总水耗</el-checkbox>
                        </div>
                        <div class="fl">
                            <el-select v-model="currentPointUnitForm.waterType" placeholder="请选择" @change="changeWater" :style="{width:100*rate+'px',height:36*rate+'px'}" :disabled="!currentPointUnitForm.waterChecked">
                                <el-option
                                v-for="item in category"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fl" :style="{marginLeft: 5*rate+'px'}">
                                <treeSelect
                                :style="{width:160*rate+'px'}"
                                v-model="currentPointUnitForm.waterCode"
                                :disabled="!currentPointUnitForm.waterChecked"
                                placeholder="请选择"
                                :clearable="false"
                                v-if="currentPointUnitForm.waterChecked==2"
                                :data="projectInfo.water.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps1"
                                ></treeSelect>
                              <treeSelect
                                :style="{width:160*rate+'px'}"
                                v-model="currentPointUnitForm.waterCode"
                                :disabled="!currentPointUnitForm.waterChecked"
                                placeholder="请选择"
                                :clearable="false"
                                v-else
                                :data="projectInfo.water.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps"
                                ></treeSelect>
                        </div>
                    </div>
                    <div class="ipt-item" style="clear: both;">
                        <div class="fl row">
                            <el-checkbox v-model="currentPointUnitForm.gasChecked" @change="((val)=>clearData(val,currentPointUnitForm,'air'))">总气耗</el-checkbox>
                        </div>
                        <div class="fl">
                            <el-select v-model="currentPointUnitForm.gasType" placeholder="请选择" @change="changeAir" :style="{width:100*rate+'px',height:36*rate+'px'}" :disabled="!currentPointUnitForm.gasChecked">
                                <el-option
                                v-for="item in category"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fl" :style="{marginLeft: 5*rate+'px'}">
                              <treeSelect
                                :style="{width:160*rate+'px'}"
                                v-model="currentPointUnitForm.gasCode"
                                :disabled="!currentPointUnitForm.gasChecked"
                                placeholder="请选择"
                                :clearable="false"
                                v-if="currentPointUnitForm.gasType==2"
                                :data="projectInfo.air.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps1"
                                ></treeSelect>
                              <treeSelect
                                :style="{width:160*rate+'px'}"
                                v-model="currentPointUnitForm.gasCode"
                                :disabled="!currentPointUnitForm.gasChecked"
                                placeholder="请选择"
                                :clearable="false"
                                v-else
                                :data="projectInfo.air.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps"
                                ></treeSelect>
                        </div>
                    </div>
                    <div class="ipt-item" style="clear: both;">
                        <div class="fl row">
                            <el-checkbox v-model="currentPointUnitForm.hotChecked" @change="((val)=>clearData(val,currentPointUnitForm,'heat'))">总热力耗</el-checkbox>
                        </div>
                        <div class="fl">
                            <el-select v-model="currentPointUnitForm.heatType" placeholder="请选择" @change="changeHeat" :style="{width:100*rate+'px',height:36*rate+'px'}" :disabled="!currentPointUnitForm.hotChecked">
                                <el-option
                                v-for="item in category"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="fl" :style="{marginLeft: 5*rate+'px'}">
                            <treeSelect
                                :style="{width:155*rate+'px'}"
                                v-model="currentPointUnitForm.heatCode"
                                placeholder="请选择"
                                :clearable="false"
                                :data="projectInfo.heat.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps1"
                                v-if="currentPointUnitForm.heatType==2"
                                :disabled="!currentPointUnitForm.hotChecked"
                                ></treeSelect>
                            <treeSelect
                                :style="{width:155*rate+'px'}"
                                v-model="currentPointUnitForm.heatCode"
                                placeholder="请选择"
                                :clearable="false"
                                v-else
                                :data="projectInfo.heat.treeConfig.dataArr"
                                :isMultiple="false"
                                :onlyLeafSelect="true"
                                :defaultProps="defaultProps"
                                :disabled="!currentPointUnitForm.hotChecked"
                                ></treeSelect>
                        </div>
                    </div>
                  
                    <p class="ipt-btn">
                        <el-button @click="deletePoint">删除</el-button>
                        <span class="ipt-space"></span>
                        <el-button type="primary" @click="savePoint">保 存</el-button>
                        
                    </p>
                </div>
            </div>
        </div>

        <!--按钮-->
        <p class="footer-btn position_a">
            <el-button @click="saveImgEdit"  type="primary">保存</el-button>
            <span class="space"></span>
            <el-button @click="cancel()">取消</el-button>
        </p>
    </div>
</template>

<script>
    /**图片编辑
     * imgEditConfig: {
     * curPmNumber:'',//项目编号
     * title:'',
     *     showPopup: false,
            url: "",
            result: "",
            pointTypeArr: []
     * }
     *
     * @save return (imgEditConfig.pointTypeArr)
     */
    import GlobalUtil from "../../utils/globalUtil";
    import treeSelect from "@/components/selectTree";
    import { getRate } from "@/utils/rate.js";
    import { getGroupingDataByNumber,getDeviceByProjectNumber,getMeterListById} from '@/services/baseInfoService';
    export default {
        name: "vImageEdit",
        components: {
            treeSelect
        },
        inject: ["imgEditConfig"],
        data() {
            return {
                rate:getRate(),
                defaultProps: {
                    label: "name",
                    children: "children",
                    key: "number",
                },
                defaultProps1: {
                    label: "name",
                    children: "children",
                    key: "number",
                },
                projectNumber:'',
                clickTimeId:null,//按下延时触发
                containerSize: {            //容器可视区域
                    width: "",
                    height: ""
                },
                imgBoxLeft: "",
                imgBoxTop: "",
                imgBoxMargin: "auto",
                defaultChecked:[],
                imgInfo: {
                    naturalWidth: "",
                    naturalHeight: "",
                    width: "",
                    height: "",
                    currentScale: 1,
                    url: "",
                    imgObj: null
                },
                //点位
                mouseDown: false,
                //鼠标操作区域位置
                mouseAreaPosition: {
                    offsetBodyLeft: 0,
                    offsetBodyTop: 0
                },
                mouseDownPoint: null,
                //鼠标移动计算过程缓存值
                pointLeft: 0,
                pointTop: 0,
                pointWidth: 24,
                /**************/
                imgEditConfigInject: null,
                pointTypeList: {
                    energy: {
                        text: "添加点位",
                        id: 1,
                        icon: "energy",
                        checked: true,
                        pointsArr: []
                    }
                },
                currentTabsKey: "energy",
                currentPointIndex: 0,
                //点位数据添加模板
                pointUnit: {
                    gasCode: "",
                    gasType: '',
                    eleCode: "",
                    eleType: '',
                    mapName: "",
                    waterCode: "",
                    waterType: '',
                    heatCode: "",
                    heatType: '',
                    pointX: "",
                    pointY: "",
                    electricitylist:[],
                    eleChecked: false,
                    waterChecked: false,
                    gasChecked: false,
                    hotChecked: false,
                    finishedStatus: false       //是否已添加信息并保存
                },
                //点位信息，界面信息详情弹窗表单用
                currentPointUnitForm: {
                    gasCode: "",
                    gasType: '',
                    eleCode: "",
                    eleType: '',
                    mapName: "",
                    waterCode: "",
                    waterType: '',
                    heatCode: "",
                    heatType: '',
                    pointX: "",
                    pointY: "",
                    electricitylist:[],
                    eleChecked: false,
                    waterChecked: false,
                    gasChecked: false,
                    hotChecked: false,
                    finishedStatus: false,//是否已添加信息并保存
                },
                deviceList:[],
                meterList:[],
                projectInfo: {
                    //-----------------------项目特有的属性
                    electricity: {
                        treeConfig: {
                            dataArr: [],
                            nodeKey: "id",
                            clearable: false,
                            valueKey: "name",
                            label: "name",
                            defaultChecked: []
                        },
                        treeitems: {sub: [], branch: [], org: [], region: []},
                    }, //电
                    water: {
                        treeConfig: {
                            dataArr: [],
                            nodeKey: "id",
                            clearable: false,
                            valueKey: "name",
                            label: "name",
                            defaultChecked: []
                        },
                        treeitems: {sub: [], branch: [], org: [], region: []}
                    },//水
                    air: {
                        treeConfig: {
                            dataArr: [],
                            nodeKey: "id",
                            clearable: false,
                            valueKey: "name",
                            label: "name",
                            defaultChecked: []
                        },
                        treeitems: {sub: [], branch: [], org: [], region: []}
                    },//气
                    heat: {
                        treeConfig: {
                            dataArr: [],
                            nodeKey: "id",
                            clearable: false,
                            valueKey: "name",
                            label: "name",
                            defaultChecked: []
                        },
                        treeitems: {sub: [], branch: [], org: [], region: []}
                    },//热力
                },
                category: [
                        {
                            value: 1,
                            label: '支路'
                        }, {
                            value: 2,
                            label: '分项'
                        }, {
                            value: 3,
                            label: '组织机构'
                        }],
                collector:[{label:'采集器',value:1}],
                //弹窗消息
                messageBox: null,
                allowMove: true,  //编辑信息状态不允许拖动
                showEditPopup: false,
                //点位信息编辑弹窗属性
                editPopupSize: {
                    width: 240,
                    height: 360,
                    left: 0,
                    top: 0,
                },
                floorList:[],//楼层信息
                fullScreen:false
            }
        },
        created() {
            //引入 图片编辑弹窗配置参数
            this.imgEditConfigInject = this.imgEditConfig;
            this.projectNumber=this.imgEditConfig.curPmNumber
            // this.getGroupingData()
            // this.getMeterListById();
            //初始化默认添加一个点位
            this.addPonit(this.currentTabsKey);
        },
        watch: {
        },
        mounted() {
            console.log(this.imgEditConfigInject,4545455)
            this.defaultProps5=this.defaultProps1
            //获取容器属性
            this.getContainerSize();
            //获取图片属性
            this.getImgInfo(this.imgEditConfigInject.url);
            this.fullScreen=this.imgEditConfigInject.fullScreen;
            //绑定全局鼠标弹起事件
            this.addEventMouseup();
        },
        methods: {
            // 获取分组
            getGroupingData () {
              getGroupingDataByNumber(this.projectNumber).then(res=>{
                  this.floorList = res.code == 200 ? res.data.array : [];
                    if (res.code != 200) {
                        this.$message.error(res.msg)
                    }
              });  
            },
            // 获取分组下面的设备故障树
            getDeviceByProjectNumber(val){
                getDeviceByProjectNumber({projectNumber:this.projectNumber,groupNumber:val}).then(res=>{
                    this.deviceList=res.code==200?res.data.array : [];
                })
            },
            // 根据项目ID获取支路列表
            getMeterListById(){
                getMeterListById({pmid:this.imgEditConfig.pmid}).then(res=>{
                    this.meterList=res.code==200?res.data.array : [];
                })
            },
            initTreeCheck(item){
                // console.log(item,'切换点位')
                item.eleType=item.eleType==0?'':Number(item.eleType)
                item.waterType=item.waterType==0?'':item.waterType
                item.gasType=item.gasType==0?'':item.gasType
                item.heatType=item.heatType==0?'':item.heatType
                if(item.eleType){
                        // this.getDeviceByProjectNumber(item.eleType)
                        this.getData(item.eleType,'electricity')
                }
                if(item.gasType){
                     this.getData(item.gasType,'air')
                }
                if(item.waterType){
                      this.getData(item.heatType,'water')
                }
                if(item.heatType){
                      this.getData(item.heatType,'heat')
                }
                this.defaultChecked=item.waterCode?item.waterCode.split(','):[]
            },
            initPointInfo() {
                let pointsArr = this.imgEditConfigInject.pointsArr;
                let scale=this.imgInfo.currentScale
                pointsArr.map(function (item) {
                    item.eleCode=item.eleCode||''
                    item.eleChecked = item.eleType ? true : false;
                    item.electricitylist=item.eleCode?item.eleCode.split(','):[]
                    item.pointX=item.pointX*scale
                    item.pointY=item.pointY*scale
                    item.waterChecked = item.waterType ? true : false;
                    item.gasChecked = item.gasType ? true : false;
                    item.hotChecked = item.heatType ? true : false;
                    item.finishedStatus = true;
                    return item;
                })
                this.pointTypeList[this.currentTabsKey].pointsArr = pointsArr;
                console.log(this.imgEditConfigInject,pointsArr,598888)
            },
            // 结束
            clearData(val,item,type){
                // console.log(val,item,type,454545)
                if(!val){
                    item[`${type}id`]=''
                    item[`${type}Type`]=''
                    if(type=='electricity'){
                        item.electricitylist=[]
                    }
                }
            },
            change(val) {
                this.getData(val,'electricity')
            },
            changeWater(val) {
                this.getData(val,'water')
            },
            changeAir(val) {
                this.getData(val,'air')
            },
            changeHeat(val) {
                this.getData(val,'heat')
            },
            getData(val,type){
                if(val==1){
                    this.projectInfo[type].treeConfig.dataArr = this.projectInfo[type].treeitems.branch;
                    // this.defaultProps5=this.defaultProps
                }else if(val==2){
                    this.projectInfo[type].treeConfig.dataArr = this.projectInfo[type].treeitems.sub;
                    //  this.defaultProps5=this.defaultProps1
                }
                else if(val==3){
                    this.projectInfo[type].treeConfig.dataArr = this.projectInfo[type].treeitems.org;
                    // this.defaultProps5=this.defaultProps1
                }
                
                // console.log(val, this.projectInfo[type].treeConfig.dataArr,78787,this.projectInfo[type].treeitems)
                //console.log( '%c -that.imgInfo.imgObj-','color:#f36c69',this.projectInfo);

            },
            changeFloor(val,item){
                item.electricitylist=[]
                this.getDeviceByProjectNumber(val)
            },
            setTreeData(type, data,subType) {
                // console.log('data',data, type)
                switch (type) {
                    case 1://电
                        this.projectInfo.electricity.treeitems.branch = data.meters;
                        this.projectInfo.electricity.treeitems.sub = data.subentrys;
                        this.projectInfo.electricity.treeitems.org = data.departments;
                        if(subType==1){ //支路
                            this.projectInfo.electricity.treeConfig.dataArr = data.meters;
                        }else if(subType==2){ //分项
                            this.projectInfo.electricity.treeConfig.dataArr = data.subentrys;
                        }
                        else if(subType==3){ //组织
                            this.projectInfo.electricity.treeConfig.dataArr = data.departments;
                        }
                        break;
                    case 2://水
                        this.projectInfo.water.treeConfig.dataArr = data.meters;
                        this.projectInfo.water.treeitems.branch = data.meters;
                        this.projectInfo.water.treeitems.sub = data.subentrys;
                        this.projectInfo.water.treeitems.org = data.departments;
                        if(subType==1){
                            this.projectInfo.water.treeConfig.dataArr = data.meters;
                        }else if(subType==2){
                            this.projectInfo.water.treeConfig.dataArr = data.subentrys;
                        }
                        else if(subType==3){
                            this.projectInfo.water.treeConfig.dataArr = data.departments;
                        }
                        break;
                    case 3://气
                        this.projectInfo.air.treeConfig.dataArr = data.meters;
                        this.projectInfo.air.treeitems.branch = data.meters;
                        this.projectInfo.air.treeitems.sub = data.subentrys;
                        this.projectInfo.air.treeitems.org = data.departments;
                        if(subType==1){
                            this.projectInfo.air.treeConfig.dataArr = data.meters;
                        }else if(subType==2){
                            this.projectInfo.air.treeConfig.dataArr = data.subentrys;
                        }
                        else if(subType==3){
                            this.projectInfo.air.treeConfig.dataArr = data.departments;
                        }
                        break;
                    case 4://热力
                        this.projectInfo.heat.treeConfig.dataArr = data.meters;
                        this.projectInfo.heat.treeitems.branch = data.meters;
                        this.projectInfo.heat.treeitems.sub = data.subentrys;
                        this.projectInfo.heat.treeitems.org = data.departments;
                        this.projectInfo.heat.treeitems.region = data.region;
                        if(subType==1){
                            this.projectInfo.heat.treeConfig.dataArr = data.meters;
                        }else if(subType==2){
                            this.projectInfo.heat.treeConfig.dataArr = data.subentrys;
                        }
                        else if(subType==3){
                            this.projectInfo.heat.treeConfig.dataArr = data.departments;
                        }
                        break;
                }
                //  console.log('data**',data, this.projectInfo)
            },
            //获取侧菜单栏数据（分项、支路、机构）
            getTreeArray() {
                let outData=this.imgEditConfigInject.outData;
                // console.log('outData',outData)
                this.setTreeData(1, outData,this.currentPointUnitForm.eleType);//电
                this.setTreeData(2, outData,this.currentPointUnitForm.waterType);//水
                this.setTreeData(3, outData,this.currentPointUnitForm.gasType);//气
                this.setTreeData(4, outData,this.currentPointUnitForm.heatType);//热力
            },
            //获取图片信息
            getImgInfo(imgUrl) {
                this.imgInfo.imgObj = new Image();
                var that = this;
                this.imgInfo.imgObj.onload = function () {
                    that.imgInfo.url = that.imgEditConfigInject.url;
                    that.imgInfo.naturalHeight = that.imgInfo.imgObj.naturalHeight
                    that.imgInfo.naturalWidth = that.imgInfo.imgObj.naturalWidth
                    that.countImgScale();
                    that.$nextTick(()=>{
                        that.getMouseMarkOffsetBody(that.$refs.mouseMark);
                    })
                };
                this.imgInfo.imgObj.onerror = (e) => {
                    console.error("图片加载失败");
                    console.error(e);
                }
                this.imgInfo.imgObj.src = imgUrl;
                
                
            },
            //获取容器实际大小
            getContainerSize() {
                this.containerSize.width = this.$refs.imgContainer.offsetWidth;
                this.containerSize.height = this.$refs.imgContainer.offsetHeight;
            },
            //计算实际显示尺寸及比例
            countImgScale() {
                // console.log(this.containerSize);
                // console.log(this.imgInfo);
                let widthScale = this.containerSize.width / this.imgInfo.naturalWidth,
                    heightScale = this.containerSize.height / this.imgInfo.naturalHeight;

                if (widthScale > heightScale) {
                    //height 100%
                    this.imgBoxTop = 0;
                    this.imgInfo.height = this.containerSize.height;
                    //缩放比例宽
                    this.imgInfo.width = this.imgInfo.height / this.imgInfo.naturalHeight * this.imgInfo.naturalWidth;
                    this.imgBoxLeft = (this.containerSize.width - this.imgInfo.width) / 2;
                    this.imgInfo.currentScale=heightScale;
                } else if (widthScale < heightScale) {
                    //width 100%
                    this.imgBoxLeft = 0;
                    this.imgInfo.width = this.containerSize.width;
                    this.imgInfo.height = this.imgInfo.width / this.imgInfo.naturalWidth * this.imgInfo.naturalHeight;
                    this.imgBoxTop = (this.containerSize.height - this.imgInfo.height) / 2;
                    this.imgInfo.currentScale=widthScale;

                } else {
                    this.imgInfo.width = this.containerSize.width;
                    this.imgInfo.height = this.containerSize.height;
                    this.imgInfo.currentScale=1;
                }
                //使用定位计算，取消margin自动计算
                //图片自身的显示比例
                // this.imgInfo.currentScale = this.imgInfo.width / this.imgInfo.naturalWidth;
                
                this.$nextTick(()=>{
                    //图片显示完成 防止闪屏
                    this.$refs.imgContainer.style.opacity = 1;
                    this.initPointInfo();
                })
            },
            //计算 mouseMark 区域的相对位置
            getMouseMarkOffsetBody(target) {
                while (target) {
                    this.mouseAreaPosition.offsetBodyLeft += target.offsetLeft;
                    this.mouseAreaPosition.offsetBodyTop += target.offsetTop;
                    target = target.offsetParent;
                    // console.log('target',target)
                }
                // console.log(this.mouseAreaPosition)
            },
            pointMouseUp(e) {
                if(this.mouseDown){
                    e.preventDefault();
                    // console.log("鼠标弹起");
                    // console.log(e.clientX);
                    // console.log(e.clientY);
                    this.mouseDown = false;
                    this.mouseDownPoint = null;
                }
            },
            //点位双击
            pointDblclick(index,event) {
                //显示编辑弹窗，禁止移动
                this.showEditPopup = true;
                this.currentPointIndex = index;
                 if(this.clickTimeId){
                     // 取消上次延时未执行的方法
                     clearTimeout(this.clickTimeId);
                 }
                // console.log("鼠标双击");
                // event.stopPropagation();
                //切换对应数据
                this.changePointData(index);
                //正在编辑 终止移动
                this.allowMove = false;
                //计算编辑弹窗的位置
                this.countEditPopupLocateInit();
                // 阻止冒泡
                return false;
            },
            addEventMouseup() {
                document.body.addEventListener("mouseup", this.pointMouseUp)
            },
            //点位按下
            pointMouseDown(event, index) {
                let This=this;
                // if(This.clickTimeId){
                //     // 取消上次延时未执行的方法
                //     clearTimeout(This.clickTimeId);
                // }
                //执行延时
                // This.clickTimeId = setTimeout(function() {
                    //此处为鼠标按下事件要执行的代码
                    //正在编辑 终止移动
                    // if(!this.allowMove) return;
                    This.currentPointIndex = index;
                    This.mouseDown = true;
                    This.mouseDownPoint = event.target;
                // }, 300);
            },
            //点位按下并移动
            mouseDownAndMove(event) {
                if (this.mouseDown) {
                    this.pointLeft = (event.clientX - this.mouseAreaPosition.offsetBodyLeft - this.pointWidth / 2);
                    this.pointTop = (event.clientY - this.mouseAreaPosition.offsetBodyTop - this.pointWidth / 2);
                    //范围限制
                    // this.pointTop =this.pointTop>0? this.pointTop:0;
                    if(this.pointLeft>=-this.pointWidth / 2&&this.pointLeft<=this.imgInfo.width-this.pointWidth / 2){
                         this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex].pointX = this.pointLeft;
                    }
                    if(this.pointTop>=-this.pointWidth / 2&&this.pointTop<=this.imgInfo.height-this.pointWidth / 2){
                            this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex].pointY = this.pointTop;
                    }
                    //输出测试
                    // console.log("相对图片X:", this.convertRealLocate(this.pointLeft, this.pointTop));
                    //  console.log("相对图片X:", event.clientX, event.clientY, this.pointLeft, this.pointTop);
                }
            },
            //转换实际X  Y 坐标值
            // convertRealLocate(pointLeft, pointTop) {
            //     return {
            //         x: (pointLeft + this.pointWidth / 2) / this.imgInfo.currentScale,
            //         y: (pointTop + this.pointWidth / 2) / this.imgInfo.currentScale
            //     }
            // },
            //添加点位按钮
            checkTabs(key) {
                this.currentTabsKey = key;
                //判断是否存在未编辑的点位
                let index = this.checkNotSavePonit(key);
                if (index !== null) {
                    //this.messageInfo({message: "存在未添加信息的点位(灰色)，请双击编辑", duration: 3000});
                    //切换到对应未添加信息的点位
                    this.pointDblclick(index);
                    return;
                }
                //添加对应点位
                this.addPonit(key);
            },
            //判断是否存在未编辑的点位
            checkNotSavePonit(key) {
                for (let i = 0, len = this.pointTypeList[key].pointsArr.length; i < len; i++) {
                    if (!this.pointTypeList[key].pointsArr[i].finishedStatus) {
                        return i;
                    }
                }
                return null;
            },
            //添加点位
            addPonit(key) {
                this.pointTypeList[key].pointsArr.push(GlobalUtil.deepCopy(this.pointUnit));
                this.currentPointUnitForm = JSON.parse(JSON.stringify(this.pointUnit)) 
            },
            //删除点位
            deletePoint() {
                if (this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex]) {
                    this.pointTypeList[this.currentTabsKey].pointsArr.splice(this.currentPointIndex, 1);
                    //关闭
                    this.closePonit()
                }
                
            },
            //计算编辑弹窗的位置
            countEditPopupLocate() {
                let currentPonit = this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex];
                //剩余高度空间
                let residualHeight = this.containerSize.height - currentPonit.pointY - this.imgBoxTop;
                //剩余宽度空间
                let residualWidth = this.containerSize.width - currentPonit.pointX- this.imgBoxLeft;
                //上下
                if ((residualHeight - this.pointWidth / 2) > this.editPopupSize.height) {
                    //高度足，显示在点位下方
                    this.editPopupSize.top = currentPonit.pointY + this.pointWidth;
                } else {
                    //高度不足，显示在点位上方
                    this.editPopupSize.top = currentPonit.pointY - this.editPopupSize.height;
                }

                //左右
                if ((residualWidth - this.pointWidth / 2) > this.editPopupSize.width) {
                    //右侧
                    this.editPopupSize.left = currentPonit.pointX + this.pointWidth;
                } else {
                    //左侧
                    this.editPopupSize.left =
                        currentPonit.pointX - this.editPopupSize.width;
                }
            },
            //计算编辑弹窗的位置
            countEditPopupLocateInit() {
                let currentPonit = this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex];
                //上下
                this.editPopupSize.top = currentPonit.pointY
                //左右
                this.editPopupSize.left = currentPonit.pointX
            },
            //切换对应的点位数据
            changePointData(index) {
                this.pointTypeList[this.currentTabsKey].pointsArr[index].finishedStatus = true;
                this.currentPointUnitForm = GlobalUtil.deepCopy(this.pointTypeList[this.currentTabsKey].pointsArr[index]);//GlobalUtil.deepCopy(
                // console.log('this.currentPointUnitForm',this.currentPointUnitForm)
                this.getTreeArray();
                this.initTreeCheck(this.currentPointUnitForm);
            },
            //保存点位编辑结果
            savePoint() {
                //名称空判断
                //选项至少选一
                // this.currentPointUnitForm.eleCode=this.currentPointUnitForm.electricitylist.length>0?this.currentPointUnitForm.electricitylist.join(','):'';
                
                if (this.imgEditConfigInject.type == 'project') {
                    this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex] = this.currentPointUnitForm;
                } else {
                    //保存除坐标以外的值 坐标需要比例转换
                    for (let key in this.currentPointUnitForm) {
                        if (key !== "pointX" && key !== "pointY") {
                            this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex][key] = this.currentPointUnitForm[key]
                        }
                    }
                }
                this.pointTypeList[this.currentTabsKey].pointsArr[this.currentPointIndex].finishedStatus = true;
                //关闭
                this.closePonit();
            },
            //关闭点位信息编辑
            closePonit() {
                //关闭编辑弹窗
                this.showEditPopup = false;
                //允许拖动
                this.allowMove = true;
            },
            //取消图片编辑
            cancel() {
                this.closePopup();
            },
            //关闭图片编辑
            closePopup() {
                // event.stopPropagation && event.stopPropagation();
                this.imgEditConfigInject.showPopup = false;
            },
            //保存图片编辑
            saveImgEdit() {
                //分发数据
                // console.error("图片编辑结果为：");
                this.pointTypeList.energy.pointsArr.forEach(item=>{
                    item.pointX=item.pointX/this.imgInfo.currentScale
                    item.pointY=item.pointY/this.imgInfo.currentScale
                    delete item.electricitylist
                    delete item.eleChecked
                    delete item.waterChecked
                    delete item.gasChecked
                    delete item.hotChecked
                })
                this.imgEditConfigInject.pointsArr = this.pointTypeList.energy.pointsArr;
                this.imgEditConfigInject.fullScreen=this.fullScreen;
                console.log(this.imgEditConfigInject,9999995555)
                //关闭
                this.closePopup();
            },
            //消息弹窗
            messageInfo(config) {
                if (!config.message) return;
                this.messageBox && this.messageBox.close();
                this.messageBox = this.$message({
                    type: config.type || "error",
                    message: config.message,
                    duration: config.duration || 3000
                })
            },
        },
        beforeDestroy() {
            this.imgInfo = null;
            //解绑鼠标弹起事件
            document.body.removeEventListener("mouseup", this.pointMouseUp);
        }
    }
</script>
<style lang="scss">
    .el-popper, .el-select-dropdown {
        z-index: 9999 !important;
    }

    .image-edit {
        .isFull{
            line-height: 30px;
            .el-checkbox__label {
                color: #666 !important;
                margin-right: 10px;
            }
        }
        .mouse-mark {
            .content-edit.project {
                width: 390px !important;
                height: 320px !important;
            }
        }
        .el-checkbox__label {
            color: white !important;
            margin-right: 10px;
        }
    }
</style>
<style scoped lang="scss">
    .image-edit .mouse-mark .content-edit .title {
        width: 100%;
    }

    .image-edit {
        width: 1100px;
        height: 740px;
        position: absolute;
        background: #fff;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        .row {
            height: 30px;
            line-height: 30px;
        }
        .image-edit-title {
            background: #1881BF;
            height: 40px;
            line-height: 40px;
            padding: 0 0 0 30px;
            color: #fff;

            .image-edit-close {
                float: right;
                margin: 12px;
                cursor: pointer;
            }
        }

        .point-list,
        .img-area {
            top: 40px;
            bottom: 50px;
        }

        .point-list {
            padding: 10px;
            left: 0;
            width: 140px;
            box-sizing: border-box;
            background: #f7f7f7;

            .point-list-box {
                background: #F7FBFC;
                border: 1px solid #E4E7EF;
                border-radius: 3px;
            }

            .item {
                text-align: center;
                width: 120px;
                height: 36px;
                line-height: 36px;
                color: #515151;
            }

            .tabs-title {
                background: #1881BF;
                color: #fff;
            }

            .operate.actived, .operate:hover {
                color: #fff;
                background: #4EB9DB;
            }
        }

        .img-area {
            left: 140px;
            right: 0;
        }

        .footer-btn {
            left: 0;
            right: 0;
            bottom: 0;
            height: 50px;
            text-align: center;
            padding: 10px 0;
            background: #f7f7f7;
            box-sizing: border-box;

            .space {
                padding: 0 20px;
            }
        }

        .img-box, .mouse-mark {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            border: 1px dotted #ff3333;
        }
        .img-box {
            z-index: 1;
            opacity: 0.5;
        }
        .mouse-mark {
            z-index: 2;

            .point {
                position: absolute;
                left: 0;
                top: 0;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                cursor: pointer;
                background: url("../../assets/images/common/img-edit-energy-gray.png") no-repeat;
                background-size: 100% 100%;
            }

            .point.finished {
                background: url("../../assets/images/common/img-edit-energy.png") no-repeat;
                background-size: 100% 100%;
            }

            .content-edit {
                width: 240px;
                height: 360px;
                background: rgba(35, 46, 52, 0.8);
                /*border-radius: 3px;*/
                top: 20px;
                left: 20px;
                ::v-deep .el-select{
                    margin-left: 0px !important;
                }
                ::v-deep .el-select .el-input__inner{
                    border-radius: 6px !important;
                    height: 32px !important;
                }
                .close {
                    right: 10px;
                    top: 12px;
                    color: #fff;
                    cursor: pointer;
                }

                .conner {
                    border: 14px solid transparent;
                    /* border-bottom-color: rgba(35,46,52,0.8);
                     top: -28px;
                     left: 106px;*/
                }

                .title {
                    font-size: 16px;
                    line-height: 40px;
                    color: #fff;
                    height: 40px;
                    text-align: center;
                    border-bottom: 1px solid #9c9c9c;
                    margin-bottom: 10px;
                }

                .ipt-item {
                    height: 24px;
                    line-height: 24px;
                    padding: 5px 10px;
                    padding-left: 15px;
                }

                .ipt-btn {
                    padding: 20px;
                    text-align: center;

                    .item {
                        width: 80px;
                        height: 24px;
                        line-height: 24px;
                        border-radius: 30px;
                        color: rgba(255, 255, 255, 0.9);
                        cursor: pointer;
                    }
                    .ipt-space {
                        padding: 0 15px
                    }
                    .save {
                        border: 0;
                        background: #0098F9;
                    }

                    .delete {
                        border: 1px solid rgba(255, 255, 255, 0.9);
                        background: none;
                    }
                }

                .sigle-ipt,
                .dobule-ipt {
                    height: 24px;
                    font-size: 16px;
                    line-height: 24px;
                    background: rgba(161, 189, 208, 0.23);
                    border: 1px solid #9C9C9C;
                    padding: 0 5px;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 14px;
                }

                .sigle-title, .dobule-title, .connect-line {
                    color: rgba(255, 255, 255, 0.9)
                }

                .sigle-ipt {
                    width: 140px;
                }

                .sigle-title {
                    width: 55px;
                    display: inline-block;
                }

                .dobule-ipt {
                    width: 40px;
                }
                .dobule-title {
                    display: inline-block;
                    width: 84px;
                }

                /*坐标文本*/
                .locate-text {
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.9);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 80px;
                    display: inline-flex;
                }
            }
        }
    }
</style>
